import BaseMoveableItem from './base_moveable_item';

export default class FriendlyAlien extends BaseMoveableItem {
    constructor(x, y) {
        super(x, y, "actors", "alienB_i.png");
        this.animations.add('idle', ["alienG_i.png"]);
        this.animations.add('move', ["alienF_w01.png","alienF_w02.png","alienF_w03.png"], 8, true);
        this.animations.add('attack', ["alienG_a01.png","alienG_a02.png","alienG_a03.png","alienG_a04.png"], 8, true);
        this.animations.add('die', ["alienG_d01.png","alienG_d02.png","alienG_d03.png"], 8);
    }

    static get phrases() {
        return {
            pick: [
                "Brr?",
                "*purring noises*",
                "bub vuv",
                "Rraaaw..",
                "Koo?",
                "Booobl woobl",
                "*bubbling noises*",
            ],
            land: [
                "Ack!",
                "Bub!",
                "Pop!",
                "Nyan!",
                "*wet smack*",
                "bub bub!",
            ]
        }
    }


    static get type() {
        return "friendly_alien";
    }

    get movingSpeed() {
        return 30;
    }

    static get mass() { return 3; }

    //this is width/height of collision box (attached to bottom)
    static get width() { return 21; }
    static get height() { return 8; }

    update() {
        if (!game.gameState.canUpdateItem()) return;
        super.update();

        if (this.walking && !this.mover.isMoving) {
            this.mover.moveRandomExceptLastEdge();
            this.animations.play('move');
        }
    }

    static get label() {
        return "friendly alien";
    }

    static get description() {
        return "This is your little acid-blooded titan-chewing cutie-pootie";
    }
}


// WEBPACK FOOTER //
// ./src/objects/items/moveable/friendly_alien.js